import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { browserRoutes } from "../../../../config/browserRoutes";

const PublicRoute = ({ children }) => {
  const authData = useSelector((state) => state?.auth);
  if (!authData?.isLogin) {
    return children;
  } else {
    return <Navigate to={browserRoutes?.dashboard} />;
  }
};

export default PublicRoute;
